import React from "react";

const Login = () => {
  return (
    <div>
      Welcome! Use these awesome forms to login or create new account in your
      project for free.
    </div>
  );
};

export default Login;